import { noCacheHeaders } from '@/services/_api/helpers'

export default (client) => {
  const root = '/tournaments'
  const v = 'v4'

  return {
    getOne({ term, version, joinGames }) {
      const params = {
        joinGames,
        version,
        term,
      }
      const url = `${root}/item`
      return client.get(url, { params, headers: noCacheHeaders })
    },
    getList({ limit = '', version, status }) {
      const url = root
      const params = {
        limit,
        version,
        status,
      }
      return client.get(url, { params, headers: noCacheHeaders })
    },
    getTournamentsListMainPage({ language }) {
      const url = `/${v}${root}/optimized`
      const params = {
        language,
      }
      return client.get(url, { params, headers: noCacheHeaders })
    },
    getUserPosition({ term, noExtra }) {
      const url = `${root}/place/${term}`
      const params = {
        extra: noExtra ? null : 2,
      }
      return client.get(url, { params })
    },
  }
}
